import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import GenericTable from '../../../../Components/GenericTable';
import { Pagination } from '@material-ui/lab';
import { Accordion, AccordionDetails, AccordionSummary, CircularProgress, Button, Typography, IconButton, Select, MenuItem, Tabs, Tab } from '@material-ui/core/';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import AppLoader from '../../../../Components/AppLoader';
import { useParams } from "react-router-dom";
import { useStyle as onboardingStyle } from '../..';
import { checkValidEmail, notify } from 'utils';
import { UserServices } from '../../../../Services/UserServices';
import { ProjectServices } from '../../../../Services/ProjectServices';
import CreateUserForm from 'Pages/Users/components/CreateUserForm';
import { useAuthDispatch, useAuthState } from '../../../../Context';
import { ERROR_MESSAGE, REQUIRED_ERROR } from '../../../../utils/constants';
import {
    JOB_PROFILE_KEYS,
    OPTIONAL_PROFILE_KEYS,
    applyProfileToPayload,
    emptyProfileFields,
    formatApiErrorMessage,
    profileFieldsFromUser,
    toMultipleUserCreateBody,
    validateProfileFields,
} from '../../../../utils/userProfileFields';
// import { initFormState } from '../CustomerAdmin';
import { pageTitleStyles } from '../../../../theme/commonStyles';
import AssignUserModal from './AssignUserModal';
import { assignFailureMessage, belongsToCustomer } from './assignUsers';
import useBulkUserUpload from '../../../../hooks/useBulkUserUpload';
import BulkUploadReport from '../../../../Components/BulkUploadReport';
import SearchBoxInput from 'Components/SearchBoxInput';
import DeleteIcon from '@material-ui/icons/Delete';
import {
    normalizeProgrammeOptions,
    profileFieldsForProgramme,
} from '../../../../utils/programmeOptions';

const userServices = new UserServices();
const projectServices = new ProjectServices();

const useStyles = makeStyles((theme) => ({
    inputStyle: {
        borderColor: '#838383',
        borderRadius: '25px',
    },
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 16,
        flexWrap: 'wrap',
        margin: '0 0 24px'
    },
    heading: {
        ...pageTitleStyles
    },
    btn: {
        padding: '13px 35px',
        background: '#3D7DDD',
        fontSize: '17px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
        "&:hover": {
            background: "#3d7ddd99"
        }
    },
    placeBtn: {
        display: 'flex',
        justifyContent: 'end',
        padding: '20px 0'
    },
    btnPwd: {
        background: '#3D7DDD',
        color: 'white',
        borderRadius: '25px',
        padding: '18px',
        marginTop: '-3px',
        marginLeft: '-42px',
        "&:hover": {
            background: "#3D7DDD"
        }
    },
    actionBar: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'stretch',
        },
    },
    actionButton: {
        padding: '12px 24px',
        borderRadius: 5,
        minWidth: 150,
        backgroundColor: '#3D7DDD',
        color: '#fff',
        border: '1px solid #3D7DDD',
        '&:hover': {
            backgroundColor: '#3d7ddd99',
            borderColor: '#3d7ddd99',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            minWidth: 0,
        },
    },
    userFormActions: {
        justifyContent: 'flex-start',
        gap: theme.spacing(1),
        [theme.breakpoints.down('xs')]: {
            '& button': {
                minWidth: 0,
            },
        },
    },
    intro: {
        marginBottom: theme.spacing(2),
    },
    introTitle: {
        color: '#1f2937',
        fontSize: '1.0625rem',
        fontWeight: 700,
        lineHeight: 1.35,
    },
    introText: {
        color: '#647184',
        fontSize: '0.8125rem',
        lineHeight: 1.5,
        marginTop: 2,
    },
    projectTabs: {
        width: '100%',
        maxWidth: '100%',
        marginBottom: theme.spacing(2),
        borderBottom: '1px solid #e1e7ee',
        '& .MuiTabs-scroller': {
            minWidth: 0,
        },
        [theme.breakpoints.down('xs')]: {
            '& .MuiTabScrollButton-root': {
                display: 'flex',
                width: 28,
            },
        },
        '& .MuiTab-root': {
            minHeight: 48,
            padding: '8px 16px',
            textTransform: 'none',
            fontWeight: 600,
            color: '#647184',
        },
        '& .Mui-selected': {
            color: theme.palette.primary.main,
        },
    },
    note: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        borderRadius: 8,
        backgroundColor: '#f4f7fb',
        color: '#4D5766',
        fontSize: '0.8125rem',
        lineHeight: 1.5,
    },
    bulkCard: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        border: '1px dashed #c5d0dc',
        borderRadius: 8,
        backgroundColor: '#fff',
    },
    bulkTitle: {
        color: '#1f2937',
        fontSize: '0.9375rem',
        fontWeight: 700,
    },
    bulkText: {
        marginTop: 4,
        marginBottom: theme.spacing(1.5),
        color: '#647184',
        fontSize: '0.75rem',
        lineHeight: 1.45,
    },
    bulkActions: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
    sectionTitle: {
        color: '#1f2937',
        fontSize: '0.9375rem',
        fontWeight: 700,
        marginBottom: theme.spacing(1.5),
    },
    addUsersAccordion: {
        marginBottom: theme.spacing(2),
        border: '1px solid var(--dm-border, #e1e7ee)',
        borderRadius: '12px !important',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: `0 0 ${theme.spacing(2)}px`,
        },
    },
    addUsersSummary: {
        minHeight: 56,
        '&.Mui-expanded': {
            minHeight: 56,
            borderBottom: '1px solid var(--dm-border, #e7ebf0)',
        },
    },
    addUsersDetails: {
        display: 'block',
        padding: theme.spacing(2),
        backgroundColor: 'var(--dm-row-alt, #f8fafc)',
        borderRadius: '0 0 12px 12px',
    },
    userBlock: {
        padding: theme.spacing(2, 2.5, 2.5),
        marginBottom: theme.spacing(2),
        border: '1px solid var(--dm-border, #e7ebf0)',
        borderRadius: 12,
        backgroundColor: 'var(--contentColor, #fff)',
        boxShadow: '0 4px 14px rgba(12, 41, 84, 0.04)',
    },
    userBlockHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.25),
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(1.5),
        borderBottom: '1px solid var(--dm-border, #e7ebf0)',
    },
    userBadge: {
        width: 26,
        height: 26,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        fontSize: '0.75rem',
        fontWeight: 700,
        color: '#fff',
        backgroundColor: theme.palette.primary.main,
    },
    userBlockTitle: {
        flex: 1,
        minWidth: 0,
        fontSize: '0.9375rem',
        fontWeight: 700,
        color: 'var(--dm-text-strong, #263548)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    removeUserBtn: {
        color: '#b42318',
        '&:hover': { backgroundColor: 'rgba(180, 35, 24, 0.08)' },
    },
    tableHead: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    emptyState: {
        padding: theme.spacing(5, 2),
        textAlign: 'center',
        color: '#647184',
        border: '1px dashed #d6dde6',
        borderRadius: 8,
    },
    continueBtn: {
        minWidth: 200,
        [theme.breakpoints.down('xs')]: {
            minWidth: 0,
        },
    },
    fileInput: {
        display: 'none',
    },
}));

const columns = [
    { label: "First name", key: 'firstName' },
    { label: "Surname", key: 'lastName' },
    { label: "Username", key: 'userName' },
    { label: "Location", key: "location" },
    { label: "Email", key: "email" },
    { label: "User Role", key: "role" },
    { label: "Action", key: "action", actions: ["edit"] }
];

const roleList = [
    {
        id: 'projectadmin',
        name: 'Project Admin'
    },
    {
        id: 'user',
        name: 'User'
    },
    {
        id: 'csmadmin',
        name: 'CSM'
    }
];
const initFormState = {
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    location: "",
    role: "",
    ...emptyProfileFields(),
};

const blankUser = () => ({ ...initFormState, is_active: "", customers: [] });


const Users = ({
    activeStep,
    handleBack,
    handleNext
}) => {

    const onBorningClasses = onboardingStyle();
    const classes = useStyles();

    const { id } = useParams();
    const customerId = id || localStorage.getItem('customerUUID');
    const dispatch = useAuthDispatch();
    const { userDetails } = useAuthState(dispatch);
    const fileInputRef = React.useRef(null);
    const formAnchorRef = React.useRef(null);

    const [projects, setProjects] = useState([]);
    const [projectsLoading, setProjectsLoading] = useState(true);
    const [selectedProjectId, setSelectedProjectId] = useState('');
    const [uploadLoading, setUploadLoading] = useState(false);
    const [addUsersOpen, setAddUsersOpen] = useState(true);
    const [openAssignUser, setOpenAssignUser] = useState(false);
    const [projectUserList, setProjectUserList] = useState([]);
    const [projectUserPage, setProjectUserPage] = useState(1);
    const [projectUserPageSize, setProjectUserPageSize] = useState(50);
    const [projectUserTotalPages, setProjectUserTotalPages] = useState(0);
    const [projectUserSearch, setProjectUserSearch] = useState('');
    const projectSearchTimer = React.useRef(null);
    const assignSearchTimer = React.useRef(null);
    const [userLoading, setUserLoading] = useState(false);
    const [companyList, setCompanyList] = React.useState([]);
    const [editCustomers, setEditCustomers] = React.useState([]);
    const [formState, setFormState] = React.useState([blankUser()]);
    const [editUserId, setEditUserId] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [editProfileReady, setEditProfileReady] = useState(false);
    const [submitLoading, setSubmitLoading] = React.useState(false);
    const [queryData, setQueryData] = useState({ search: '' });
    const [assignedUserList, setAssignedUserList] = useState([]);
    const [assignUserLoading, setAssignUserLoading] = useState(false);
    const [assignUserPage, setAssignUserPage] = useState(1);
    const [assignUserPageSize, setAssignUserPageSize] = useState(50);
    const [assignUserTotal, setAssignUserTotal] = useState(0);
    const [assignSubmitLoading, setAssignSubmitLoading] = useState(false);
    const [editFormState, setEditFormState] = React.useState({ ...blankUser() });
    const [programmeOptions, setProgrammeOptions] = useState(null);
    const [templateProgrammeLabel, setTemplateProgrammeLabel] = useState('');

    const customerCompany = companyList.find(company => company.uuid === customerId) || null;

    const handleBulkFinished = (result) => {
        const failed = result?.failed?.length || 0;
        const processed = (result?.created?.length || 0) + (result?.updated?.length || 0) + (result?.moved?.length || 0);
        if (result?.state === 'failed') notify('error', result.message || 'The upload did not finish.');
        else if (failed) notify('warning', `${processed} users processed, ${failed} failed. See the report below.`);
        else notify('success', result?.message || `${processed} users processed.`);
        if (selectedProjectId) getProjectUser(selectedProjectId);
        loadProjects();
    };
    const bulkUpload = useBulkUserUpload({ customerId, onFinished: handleBulkFinished });

    const blankCustomerUser = () => ({
        ...blankUser(),
        customers: customerCompany ? [customerCompany] : [],
    });

    const loadProjects = async () => {
        const projectsRes = await projectServices.allProjectsByCustomer(customerId);
        const rows = projectsRes?.results || [];
        setProjects(rows);
        return rows;
    };

    useEffect(() => {
        localStorage.setItem('userbyproject', true);
        let cancelled = false;
        Promise.all([
            loadProjects(),
            projectServices.getProgrammeOptions(),
        ])
            .then(([rows, optionsResult]) => {
                if (cancelled) return rows;
                if (optionsResult?.status) setProgrammeOptions(normalizeProgrammeOptions(optionsResult));
                return rows;
            })
            .then((rows) => {
                if (cancelled) return;
                const stored = localStorage.getItem('project_id');
                const initial = rows.find(row => row.project_uuid === stored) || rows[0];
                if (initial?.project_uuid) {
                    setSelectedProjectId(initial.project_uuid);
                    localStorage.setItem('project_id', initial.project_uuid);
                }
            })
            .catch(error => {
                if (!cancelled) notify('error', error?.response?.data?.message || 'Could not load projects and programme options.');
            })
            .finally(() => {
                if (!cancelled) setProjectsLoading(false);
            });
        return () => {
            cancelled = true;
        };
    // Route customer changes remount this screen; keep the coordinated initial load single-run.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId]);

    useEffect(() => {
        if (!selectedProjectId) return undefined;
        localStorage.setItem('project_id', selectedProjectId);
        const delay = projectUserSearch ? 400 : 0;
        projectSearchTimer.current = setTimeout(() => {
            getProjectUser(selectedProjectId, 1, projectUserPageSize, projectUserSearch);
        }, delay);
        return () => clearTimeout(projectSearchTimer.current);
    // Page-size changes fetch explicitly; this effect owns project/search transitions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProjectId, projectUserSearch]);

    async function getProjectUser(project_id, page = projectUserPage, pageSize = projectUserPageSize, search = projectUserSearch) {
        setUserLoading(true);
        try {
            const projectUserRes = await projectServices.userByProject(project_id, { page, pageSize, search });
            const data = projectUserRes?.data;
            const users = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
            const size = data?.page_size || pageSize;
            const totalPages = data?.total_pages
                || (data?.total ? Math.ceil(Number(data.total) / size) : (users.length ? 1 : 0));
            setProjectUserList(users);
            setProjectUserPage(data?.page || page);
            setProjectUserPageSize(size);
            setProjectUserTotalPages(totalPages);
        } catch (err) {
            const body = err?.response?.data;
            notify('error', body?.message || 'Could not load project users.');
            setProjectUserList([]);
            setProjectUserTotalPages(0);
        } finally {
            setUserLoading(false);
        }
    }

    const getAllUser = async ({ search = '', page = 1, pageSize = assignUserPageSize } = {}) => {
        setAssignUserLoading(true);
        const params = new URLSearchParams({
            search,
            page: String(page),
            page_size: String(pageSize),
        });
        if (customerId) params.set('customer_id', customerId);
        try {
            const userResult = await userServices.getAllUser(`main/userlist/all?${params.toString()}`);
            if (userResult && userResult.status === false) {
                notify('error', userResult.message || 'Could not load users.');
                setAssignedUserList([]);
                setAssignUserTotal(0);
                return;
            }
            const payload = userResult?.data && !Array.isArray(userResult.data) ? userResult.data : null;
            const users = Array.isArray(payload?.results) ? payload.results : [];
            setAssignedUserList(users.filter(user => belongsToCustomer(user, customerId)));
            setAssignUserPage(payload?.page || page);
            setAssignUserPageSize(payload?.page_size || pageSize);
            setAssignUserTotal(Number(payload?.total) || 0);
        } catch (err) {
            const data = err?.response?.data;
            const message = (typeof data === 'string' && data) || data?.message || data?.detail || 'Could not load users.';
            notify('error', message);
            setAssignedUserList([]);
            setAssignUserTotal(0);
        } finally {
            setAssignUserLoading(false);
        }
    };

    const handleProjectUserPageChange = (event, page) => {
        clearTimeout(projectSearchTimer.current);
        setProjectUserPage(page);
        if (selectedProjectId) getProjectUser(selectedProjectId, page, projectUserPageSize, projectUserSearch);
    };

    const handleProjectUserPageSizeChange = (event) => {
        clearTimeout(projectSearchTimer.current);
        const pageSize = Number(event.target.value);
        setProjectUserPage(1);
        setProjectUserPageSize(pageSize);
        if (selectedProjectId) getProjectUser(selectedProjectId, 1, pageSize, projectUserSearch);
    };

    const handleProjectUserSearch = (event) => {
        clearTimeout(projectSearchTimer.current);
        event.preventDefault();
        setProjectUserPage(1);
        if (selectedProjectId) getProjectUser(selectedProjectId, 1, projectUserPageSize, projectUserSearch);
    };

    const handleSelectProject = (event, projectId) => {
        setSelectedProjectId(projectId);
        setProjectUserSearch('');
        setProjectUserPage(1);
        if (!bulkUpload.uploading) bulkUpload.reset();
        setEditUserId(null);
        setEditProfileReady(false);
        setEditFormState(blankUser());
        setEditCustomers([]);
        setFormState([blankCustomerUser()]);
    };

    const handleItemClick = async (row) => {
        if (!row) return null;
        setEditUserId(row.uuid);
        setAddUsersOpen(true);
        setEditLoading(true);
        if (formAnchorRef.current) formAnchorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setEditProfileReady(false);
        let selectedComp = companyList.filter(itm => row?.company_ids?.includes(itm.uuid));
        setEditCustomers(selectedComp);
        let userData = row;
        let profileReady = false;
        try {
            const detail = await userServices.getUserDetail(row.uuid);
            if (detail?.status && detail.data && detail.data[0]) {
                userData = detail.data[0];
                profileReady = true;
                if (userData.customers?.length) {
                    selectedComp = companyList.filter(itm => userData.customers.includes(itm.uuid));
                    setEditCustomers(selectedComp);
                }
            }
        } catch (err) {
            notify('error', 'Could not load this user.');
        }
        setEditProfileReady(profileReady);
        setEditFormState({
            firstName: userData.firstName || '',
            lastName: userData.lastName || '',
            email: userData.email || '',
            userName: userData.userName || '',
            role: userData.role || '',
            location: userData.location || '',
            password: "",
            is_active: row.user__is_active,
            ...profileFieldsFromUser(userData),
        });
        setEditLoading(false);
    }

    const handleInputChange = (evt, idx) => {
        const { name, value } = evt.target;
        if (editUserId) {
            if (name === 'email') {
                setEditFormState({ ...editFormState, email: value, userName: value });
            } else {
                setEditFormState({ ...editFormState, [name]: value });
            }
        } else {
            setFormState((prevState) => {
                const newState = [...prevState];
                const current = { ...newState[idx] };
                if (name === 'email') {
                    current.email = value;
                    current.userName = value;
                } else {
                    current[name] = value;
                }
                newState[idx] = current;
                return newState;
            });
        }
    }

    const handleFieldsChange = (patch, idx) => {
        if (editUserId) {
            setEditFormState((prev) => ({ ...prev, ...patch }));
            return;
        }
        setFormState((prevState) => {
            const newState = [...prevState];
            newState[idx] = { ...newState[idx], ...patch };
            return newState;
        });
    }

    React.useEffect(() => {
        if (!customerCompany) return;
        setFormState((prev) => prev.map((user) => (
            user.customers?.length ? user : { ...user, customers: [customerCompany] }
        )));
    }, [customerCompany]);

    React.useEffect(() => {
        getCompanyList();
    // Company data is refreshed only when the route customer changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId]);

    const getCompanyList = async () => {
        const compResult = await userServices.customerDropdown(customerId);
        if (compResult && compResult.data) {
            localStorage.setItem('getAllCustomer', false);
            setCompanyList(compResult.data);
        }
    }

    const handleChangeCustomer = (value, idx) => {
        if (editUserId) {
            setEditCustomers(value);
        } else {
            setFormState((prevState) => {
                let newState = [...prevState];
                newState[idx]['customers'] = value;
                return newState;
            });
        }
    }

    const formValidationCheck = (evt) => {
        const project = projects.find(item => item.project_uuid === selectedProjectId);
        const programmeType = project?.programme_type || '';
        const programmeProfileFields = profileFieldsForProgramme(programmeOptions, programmeType);
        if (!editUserId) {
            let valid = true;
            let emailValid = true;
            let errorEmails = [];
            let duplicatesEmails = [];
            let duplicateUserName = [];
            let compError = false;
            formState.forEach((item) => {
                if (!item.firstName || !item.lastName || !item.userName || !item.email || !item.location || !item.role) {
                    valid = false
                }
                if (!item.customers?.length) {
                    compError = true;
                }

                if (!checkValidEmail(item.email)) {
                    emailValid = false;
                    errorEmails.push(item.email);
                }
                let checkDuplicateEmail = formState.filter(itm => (itm.email === item.email));
                if (checkDuplicateEmail.length > 1) {
                    duplicatesEmails.push(item.email);
                }
                let checkDuplicateUserNm = formState.filter(itm => (itm.userName === item.userName));
                if (checkDuplicateUserNm.length > 1) {
                    duplicateUserName.push(item.userName);
                }
            });
            if (!valid) {
                notify("error", REQUIRED_ERROR);
                return null;
            }
            if (compError) {
                notify("error", ERROR_MESSAGE.SELECT_COMPANY);
                return null;
            }

            if (!emailValid) {
                notify('error', `Please enter valid email address, ${errorEmails.length ? errorEmails?.join(", ") : ""}`);
                return null;
            }
            if (duplicatesEmails.length) {
                notify('error', `Emails are duplicates, ${duplicatesEmails?.join(", ")}`);
                return null;
            }
            if (duplicateUserName.length) {
                notify('error', `Username are duplicates, ${duplicateUserName?.join(", ")}`);
                return null;
            }
            const profileError = formState.map((item, index) => {
                const error = validateProfileFields(item, {
                    programmeType,
                    profileFields: programmeProfileFields,
                });
                return error ? `User ${index + 1}: ${error}` : null;
            }).find(Boolean);
            if (profileError) {
                notify('error', profileError);
                return null;
            }
        } else {
            if (editLoading) return null;
            if (!editFormState.firstName || !editFormState.lastName || !editFormState.userName || !editFormState.email) {
                notify("error", REQUIRED_ERROR);
                return null;
            }
            const profileError = validateProfileFields(editFormState, {
                isEdit: true,
                programmeType,
                profileFields: programmeProfileFields,
            });
            if (profileError) {
                notify('error', profileError);
                return null;
            }
        }
        return handleFormSubmit(evt);
    }

    const handleFormSubmit = async (evt) => {
        setSubmitLoading(true);
        let uuid = null;
        let payload = null;
        const project_id = selectedProjectId || localStorage.getItem('project_id');
        const project = projects.find(item => item.project_uuid === project_id);
        const programmeType = project?.programme_type || '';
        const programmeProfileFields = profileFieldsForProgramme(programmeOptions, programmeType);
        if (editUserId) {
            uuid = editUserId;
            let customersIds = editCustomers.map(cs => cs.uuid);
            payload = applyProfileToPayload({
                ...editFormState,
                userName: editFormState.email,
                customers: customersIds,
                updates: 'true'
            }, editFormState, {
                isEdit: true,
                programmeType,
                profileFields: programmeProfileFields,
            });
            delete payload.password;
            if (!editProfileReady) {
                [...OPTIONAL_PROFILE_KEYS, ...JOB_PROFILE_KEYS].forEach((key) => {
                    if (payload[key] == null) delete payload[key];
                });
            }
        } else {
            uuid = null;
            payload = toMultipleUserCreateBody(formState, project_id, {
                programmeType,
                profileFields: programmeProfileFields,
            });
        }
        const result = await userServices.addMultipleUser(payload, uuid);
        if (result && result.status) {
            notify("success", result.message)
            setSubmitLoading(false);
            setEditUserId(null);
            setEditProfileReady(false);
            setEditFormState(blankUser());
            setEditCustomers([]);
            setFormState([blankCustomerUser()]);
            if (selectedProjectId) getProjectUser(selectedProjectId, 1, projectUserPageSize, projectUserSearch);
            loadProjects();
        } else {
            setSubmitLoading(false);
            let errorMsg = formatApiErrorMessage(result);
            if (result && result.message && result.message?.email_errors?.length) {
                errorMsg = result.message?.email_errors[0];
            } else if (result && result.message && result.message?.username_errors?.length) {
                errorMsg = result.message?.username_errors[0];
            }
            notify("error", errorMsg);
        }
        setSubmitLoading(false);
    }

    const handleRemoveUser = (idx) => {
        setFormState((prevState) => {
            let newState = [...prevState];
            newState.splice(idx, 1);
            return newState;
        });
    }

    const handleAssignUserToProject = async (users) => {
        if (!users?.length || !selectedProjectId) return;
        setAssignSubmitLoading(true);
        try {
            const assignRes = await projectServices.assignProjectToUsers({
                projectId: selectedProjectId,
                userIds: [...users],
            });
            if (assignRes && assignRes.status) {
                notify('success', users.length === 1 ? '1 user added to this project.' : `${users.length} users added to this project.`);
                setOpenAssignUser(false);
                setQueryData({ search: '' });
                getProjectUser(selectedProjectId);
                loadProjects();
            } else {
                notify('error', assignFailureMessage(assignRes));
            }
        } finally {
            setAssignSubmitLoading(false);
        }
    }

    const handleDownloadTemplate = async () => {
        setUploadLoading(true);
        try {
            const data = await userServices.getBulkTemplate(customerId, { projectId: selectedProjectId });
            const templateUrl = data?.data?.url;
            if (!templateUrl) {
                notify('error', 'Something went wrong');
                return;
            }
            const link = document.createElement('a');
            const cacheBuster = /X-Amz-Signature|Signature=/.test(templateUrl) ? '' : `${templateUrl.includes('?') ? '&' : '?'}t=${Date.now()}`;
            link.href = `${templateUrl}${cacheBuster}`;
            link.setAttribute('download', 'bulkupload.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTemplateProgrammeLabel(data?.data?.programme_type_label || '');
            notify('success', 'Sample Template downloaded successfully');
        } catch (error) {
            notify('error', 'Something went wrong');
        } finally {
            setUploadLoading(false);
        }
    };

    const handleUploadTemplate = (event) => {
        const file = event.target.files && event.target.files[0];
        event.target.value = '';
        if (file) bulkUpload.upload(file);
    };

    React.useEffect(() => {
        if (!openAssignUser) return undefined;
        const delay = queryData.search ? 800 : 0;
        assignSearchTimer.current = setTimeout(() => {
            getAllUser({ page: 1, search: queryData.search, pageSize: assignUserPageSize });
        }, delay);
        return () => clearTimeout(assignSearchTimer.current);
    // Page-size changes fetch explicitly; this debounce owns modal search/open transitions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryData.search, openAssignUser]);


    const selectedProject = projects.find(project => project.project_uuid === selectedProjectId);
    const selectedProjectName = selectedProject?.project_name || 'this project';
    const selectedProgrammeType = selectedProject?.programme_type || '';
    const selectedProgrammeFields = profileFieldsForProgramme(programmeOptions, selectedProgrammeType);

    return (
        <>
            <div className={classes.intro}>
                <Typography component="h2" className={classes.introTitle}>Add users to projects</Typography>
                <Typography className={classes.introText}>
                    Add the people who will use the services, project by project. Upload in bulk or add one at a time.
                </Typography>
            </div>
            {projectsLoading ? (
                <AppLoader minHeight={240} />
            ) : !projects.length ? (
                <div className={classes.emptyState}>
                    No projects yet. Go back and create a project before adding users.
                </div>
            ) : (
                <>
                    <Tabs
                        className={classes.projectTabs}
                        value={selectedProjectId}
                        onChange={handleSelectProject}
                        variant="scrollable"
                        scrollButtons="auto"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        {projects.map(project => (
                            <Tab
                                key={project.project_uuid}
                                value={project.project_uuid}
                                label={`${project.project_name || 'Untitled project'}${Number.isFinite(Number(project.total_users)) ? ` · ${project.total_users} users` : ''}`}
                            />
                        ))}
                    </Tabs>
                    <div className={classes.note}>
                        Users can complete their programme profile later. Only the fields marked * are needed to create a user.
                    </div>
                    <div className={classes.bulkCard}>
                        <Typography className={classes.bulkTitle}>Bulk upload users</Typography>
                        <Typography className={classes.bulkText}>
                            Download the template, fill it in, then upload it for this project.
                        </Typography>
                        {templateProgrammeLabel && (
                            <Typography className={classes.bulkText}>Template for: {templateProgrammeLabel}</Typography>
                        )}
                        <div className={classes.bulkActions}>
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                startIcon={<GetAppIcon />}
                                onClick={handleDownloadTemplate}
                                disabled={uploadLoading}
                            >
                                Download template
                            </Button>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                startIcon={<CloudUploadIcon />}
                                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                disabled={uploadLoading || bulkUpload.uploading}
                            >
                                {bulkUpload.uploading ? <CircularProgress size={18} color="inherit" /> : 'Upload Excel file'}
                            </Button>
                            <input
                                ref={fileInputRef}
                                className={classes.fileInput}
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={handleUploadTemplate}
                            />
                        </div>
                        <BulkUploadReport job={bulkUpload.job} error={bulkUpload.error} onClose={bulkUpload.reset} />
                    </div>
                    <Accordion
                        ref={formAnchorRef}
                        expanded={addUsersOpen}
                        onChange={(event, open) => setAddUsersOpen(open)}
                        className={classes.addUsersAccordion}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.addUsersSummary}>
                            <Typography className={classes.sectionTitle} style={{ marginBottom: 0 }}>
                                {editUserId ? 'Edit user' : 'Add users'}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.addUsersDetails}>
                    {editUserId ? (
                        editLoading ? <AppLoader minHeight={180} /> : (
                            <div className={classes.userBlock}>
                            <div className={classes.userBlockHeader}>
                                <Typography component="h3" className={classes.userBlockTitle}>
                                    {[editFormState.firstName, editFormState.lastName].filter(Boolean).join(' ') || 'Edit user'}
                                </Typography>
                            </div>
                            <CreateUserForm
                                formState={editFormState}
                                handleChangeCustomer={handleChangeCustomer}
                                handleInputChange={handleInputChange}
                                companyList={companyList}
                                customers={editCustomers}
                                roleList={roleList}
                                userNameDisable
                                emailDisable
                                userDetails={userDetails}
                                isOnbaording
                                showProfileFields
                                handleFieldsChange={handleFieldsChange}
                                programmeType={selectedProgrammeType}
                                programmeTypeLabel={selectedProject?.programme_type_label || ''}
                                programmeProfileFields={selectedProgrammeFields}
                            />
                            </div>
                        )
                    ) : formState.map((itm, index) => (
                        <div key={`new-user-${index}`} className={classes.userBlock}>
                            <div className={classes.userBlockHeader}>
                                <span className={classes.userBadge} aria-hidden="true">{index + 1}</span>
                                <Typography component="h3" className={classes.userBlockTitle}>
                                    {[itm.firstName, itm.lastName].filter(Boolean).join(' ') || `User ${index + 1}`}
                                </Typography>
                                {index > 0 && (
                                    <IconButton
                                        size="small"
                                        className={classes.removeUserBtn}
                                        aria-label={`Remove user ${index + 1}`}
                                        onClick={() => handleRemoveUser(index)}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </div>
                            <CreateUserForm
                                formState={itm}
                                handleChangeCustomer={evt => handleChangeCustomer(evt, index)}
                                handleInputChange={evt => handleInputChange(evt, index)}
                                companyList={companyList}
                                customers={itm.customers || []}
                                roleList={roleList}
                                userDetails={userDetails}
                                isOnbaording
                                showProfileFields
                                handleFieldsChange={(patch) => handleFieldsChange(patch, index)}
                                programmeType={selectedProgrammeType}
                                programmeTypeLabel={selectedProject?.programme_type_label || ''}
                                programmeProfileFields={selectedProgrammeFields}
                            />
                        </div>
                    ))}
                    <div className={classes.userFormActions} style={{ display: 'flex', marginTop: 8 }}>
                        {editUserId ? (
                            <Button
                                type="button"
                                variant="outlined"
                                color="default"
                                onClick={() => {
                                    setEditUserId(null);
                                    setEditProfileReady(false);
                                    setEditFormState(blankUser());
                                    setEditCustomers([]);
                                }}
                            >
                                Cancel
                            </Button>
                        ) : (
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                onClick={() => setFormState([...formState, blankCustomerUser()])}
                            >
                                Add new
                            </Button>
                        )}
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={formValidationCheck}
                            disabled={submitLoading || editLoading}
                        >
                            {submitLoading ? <CircularProgress size={18} color="inherit" /> : (editUserId ? 'Save' : 'Add user')}
                        </Button>
                    </div>
                        </AccordionDetails>
                    </Accordion>
                    <div className={classes.tableHead}>
                        <Typography className={classes.sectionTitle} style={{ marginBottom: 0 }}>
                            Users in {selectedProjectName}
                        </Typography>
                        <div className={classes.bulkActions}>
                            <SearchBoxInput
                                value={projectUserSearch}
                                handleChange={(event) => setProjectUserSearch(event.target.value)}
                                handleSearch={handleProjectUserSearch}
                                placeholder="Search users"
                                styleOverrides={{ width: 240, minWidth: 0 }}
                            />
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                onClick={() => setOpenAssignUser(true)}
                            >
                                Assign users
                            </Button>
                        </div>
                    </div>
                    <GenericTable
                        columns={columns}
                        loading={userLoading}
                        handleItemClick={handleItemClick}
                        list={projectUserList}
                    />
                    <Grid container alignItems="center" justifyContent="space-between" style={{ marginTop: 22 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#4D5766' }}>
                            Rows
                            <Select
                                variant="outlined"
                                margin="dense"
                                value={projectUserPageSize}
                                onChange={handleProjectUserPageSizeChange}
                                style={{ minWidth: 72 }}
                            >
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                            </Select>
                        </div>
                        {projectUserTotalPages > 1 && (
                            <Pagination
                                page={projectUserPage}
                                onChange={handleProjectUserPageChange}
                                count={projectUserTotalPages}
                                variant="outlined"
                                shape="rounded"
                                siblingCount={0}
                            />
                        )}
                    </Grid>
                </>
            )}
            <div className={onBorningClasses.buttons}>
                <div className={onBorningClasses.wrapper}>
                    {activeStep !== 0 && (
                        <Button
                            type="button"
                            onClick={handleBack}
                            variant="outlined"
                            color="default"
                            className={onBorningClasses.cancelBtn}
                        >
                            Back
                        </Button>
                    )}
                    <Button
                        type="button"
                        onClick={handleNext}
                        variant="contained"
                        color="primary"
                        endIcon={<ArrowForwardIcon fontSize="small" />}
                        className={`${onBorningClasses.button} ${classes.continueBtn}`}
                    >
                        Continue to Assignment
                    </Button>
                </div>
            </div>
            <AssignUserModal
                open={openAssignUser}
                loading={assignUserLoading}
                list={assignedUserList}
                handleSubmit={handleAssignUserToProject}
                submitLoading={assignSubmitLoading}
                targetProjectId={selectedProjectId}
                projectNames={Object.fromEntries(projects.map(row => [row.project_uuid, row.project_name]))}
                queryData={queryData}
                page={assignUserPage}
                pageSize={assignUserPageSize}
                total={assignUserTotal}
                onPageChange={(gridPage) => {
                    clearTimeout(assignSearchTimer.current);
                    const page = Number(gridPage) + 1;
                    setAssignUserPage(page);
                    getAllUser({ search: queryData.search, page, pageSize: assignUserPageSize });
                }}
                onPageSizeChange={(pageSize) => {
                    clearTimeout(assignSearchTimer.current);
                    setAssignUserPage(1);
                    setAssignUserPageSize(pageSize);
                    getAllUser({ search: queryData.search, page: 1, pageSize });
                }}
                handleChange={(evt) => setQueryData({ search: evt.target.value })}
                handleSearch={evt => {
                    clearTimeout(assignSearchTimer.current);
                    evt.preventDefault();
                    setAssignUserPage(1);
                    return getAllUser({ search: queryData.search, page: 1, pageSize: assignUserPageSize });
                }}
                handleClose={() => {
                    clearTimeout(assignSearchTimer.current);
                    setOpenAssignUser(false);
                    setAssignedUserList([]);
                    setAssignUserPage(1);
                    setAssignUserTotal(0);
                    setQueryData({ search: '' });
                }}
            />
        </>
    );
}

export default Users;
